import React from "react";

const SectionContainer = ({ title, className, children }) => {
    return (
        <div className={`section inner ${className?className:''}`}>
            <div className="title">
                <h2>{title}</h2>
            </div>
            {children}  
        </div>
    );
}

export default SectionContainer;